export default {
  no_storefront_found: {
    title: 'Nicio vitrină găsită',
    description: 'Vă rugăm să creați o vitrină.',
  },
};
